import React, { useState } from "react";
import { CreditServiceInterface } from "../../intrefaces/credit/credit.interface";
import { Checkbox } from "../Checkbox";
import { useCreditDispatch } from "../../stores/credit/credit.store";
import { toggleService } from "../../stores/credit/credit.reducer";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { useCreditSelector } from "../../stores/product/product.store";

interface ServiceProps {
    service: CreditServiceInterface;
    isRequire?: boolean;
}

export const Service: React.FC<ServiceProps> = ({ service, isRequire = false }) => {
    const additionalServices = useCreditSelector((state: CreditState) => state.additionalServices);
    const [checked, setChecked] = useState(isRequire || additionalServices.includes(service.id));
    const dispatch = useCreditDispatch();
    const change = (checked: boolean) => {
        if(!isRequire) {
            setChecked(checked);
            dispatch(toggleService({ id: service.id, state: checked }));
        } else {
            setChecked(true);
        }
    }

    return (
        <>
            <div className="flex items-center">
                <Checkbox id={ `service_${service.id}` } checked={ checked } onChange={ change } isFilled={ false } />
                <label htmlFor={ `service_${service.id}` } className="text-sm font-medium text-black">
                    { service.name }
                    <span className="text-gray"> { service.extraFee }</span>
                </label>
            </div>
        </>
    )
}